import { Model } from '@vuex-orm/core'
import GroupChatPost from '@/store/models/GroupChatPost'

export default class GroupChat extends Model {
  static entity = 'groupChats'

  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      groupChatName: this.string(''),
      groupChatDescription: this.string(null).nullable(),
      groupChatOwnerId: this.attr(null),
      groupChatType: this.string(''),
      projectId: this.attr(null),
      unreadCount: this.number(0),
      isListable: this.boolean(false),
      isArchived: this.boolean(false),
      recentPostAt: this.attr(null),
      users: this.attr([]),
      userIds: this.attr([]),
      groupChatPosts: this.hasMany(GroupChatPost, 'groupChatId'),
      meta: this.attr(null)
    }
  }

  static permitAttributes = [
    'groupChatName',
    'groupChatDescription',
    'groupChatOwnerId',
    'groupChatType',
    'userIds'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }

  static listables() {
    return this.query().where(groupChat => {
      return groupChat.isListable && !groupChat.isArchived
    }).get()
  }

  isPublic() {
    return this.groupChatType === 'publicChat'
  }

  isProject() {
    return this.projectId != null
  }
}
